import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { DEMO_VIDEO_URL } from "../../../../../constants/support";
import ContactMenu from "./ContactMenu";

/**
 * "Demo on YouTube" and "Contact us": the help a business is offered on the
 * pages where it configures things it has never configured before — the setup
 * wizard and Site & widget. A fragment, so it sits in whatever row the caller
 * puts it in. Below `md` both shrink to their icons. The wizard passes the
 * video for the step on screen; elsewhere it is the general walkthrough.
 */
const HelpLinks = ({ videoUrl = DEMO_VIDEO_URL }) => {
  const { t } = useTranslation();

  return (
    <>
      <a
        href={videoUrl}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={t("Dashboard.Setup.topBar.demo")}
        className="inline-flex min-h-11 min-w-11 items-center justify-center gap-2 rounded-lg px-2.5 text-sm font-medium text-ink-700 no-underline transition hover:bg-ink-100 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-600"
      >
        <i className="bi bi-youtube text-xl text-red-600" aria-hidden="true" />
        <span className="hidden md:inline">{t("Dashboard.Setup.topBar.demo")}</span>
      </a>
      <ContactMenu />
    </>
  );
};

HelpLinks.propTypes = {
  videoUrl: PropTypes.string,
};

export default HelpLinks;
